<template>
  <v-layout wrap>
    <v-flex xs12>
      <v-select
        label="Variável 1:"
        :items="nonSelectedComponentsRow1"
        item-text="label"
        item-value="id"
        return-object
        clearable
        v-model="variables.row1"
        :disabled="row1Disabled"
      />
    </v-flex>
    <v-flex
      v-if="
        displayMode &&
        displayMode == 'table' &&
        showDimension1 &&
        variables.row1 &&
        variables.row1.id !== 'anesthesia-procedure' &&
        !isConditional
      "
      xs12
    >
      <v-select
        v-model="variables.row2"
        label="Dividir por (outra variável):"
        :items="nonSelectedComponentsRow2"
        item-text="label"
        item-value="id"
        return-object
        clearable
        :disabled="isDisabled"
      />
    </v-flex>
    <v-flex
      v-if="
        displayMode &&
        displayMode != 'pie-chart' &&
        (variables.row1 || displayMode != 'bar-chart') &&
        !isConditional
      "
      xs12
    >
      <v-select
        v-model="variables.column1"
        label="Variável 2:"
        :items="nonSelectedComponentsColumn1"
        item-text="label"
        item-value="id"
        return-object
        clearable
        :disabled="isDisabled"
      />
    </v-flex>
    <v-flex
      v-if="
        variables.column1 &&
        displayMode &&
        displayMode == 'table' &&
        !isConditional
      "
      xs12
    >
      <v-select
        v-model="variables.column2"
        label="Dividir por (outra variável):"
        :items="nonSelectedComponentsColumn2"
        item-text="label"
        item-value="id"
        return-object
        clearable
        :disabled="isDisabled"
      />
    </v-flex>
    <v-flex v-if="isConditional" x12>
      <v-select
        label="Variável 2:"
        v-model="variables.condition"
        :items="variableOptions"
        clearable
      />
    </v-flex>
  </v-layout>
</template>

<script>
import helpers from './mixins/statsHelperFunc'
export default {
  props: {
    displayMode: { type: String },
    logbookType: { type: String },
    interns: { type: Boolean, default: false },
    vars: { type: Object },
    row1Disabled: { type: Boolean }
  },
  mixins: [helpers],
  data() {
    return {
      isDisabled: false,
      isConditional: false,
      variableOptions: [],
      variables: {
        row1: null,
        row2: null,
        column1: null,
        column2: null,
        condition: null
      }
    }
  },
  computed: {
    allComponents() {
      return this.allStatsComponents(this.logbookType).filter(
        c => c.type !== 'autonomy'
      )
    },
    showDimension1() {
      return this.interns === false
    },
    nonSelectedComponentsRow1() {
      return this.allComponents.filter(
        c =>
          (!this.variables.column1 || c.id != this.variables.column1.id) &&
          (!this.variables.column2 || c.id != this.variables.column2.id) &&
          (!this.variables.row2 || c.id != this.variables.row2.id) &&
          c.id != 'anesthesia-procedure'
      )
    },
    nonSelectedComponentsRow2() {
      return this.allComponents.filter(
        c =>
          (!this.variables.column1 || c.id != this.variables.column1.id) &&
          (!this.variables.column2 || c.id != this.variables.column2.id) &&
          (!this.variables.row1 || c.id != this.variables.row1.id) &&
          c.id != 'anesthesia-procedure' &&
          c.type !== 'multi-select-tree'
      )
    },
    nonSelectedComponentsColumn1() {
      return this.allComponents.filter(
        c =>
          (!this.variables.column2 || c.id != this.variables.column2.id) &&
          (!this.variables.row1 || c.id != this.variables.row1.id) &&
          (!this.variables.row2 || c.id != this.variables.row2.id) &&
          c.id != 'anesthesia-procedure' &&
          c.type !== 'multi-select-tree'
      )
    },
    nonSelectedComponentsColumn2() {
      return this.allComponents.filter(
        c =>
          (!this.variables.column1 || c.id != this.variables.column1.id) &&
          (!this.variables.row1 || c.id != this.variables.row1.id) &&
          (!this.variables.row2 || c.id != this.variables.row2.id) &&
          c.id != 'anesthesia-procedure'
      )
    }
  },
  mounted() {
    this.$root.$on('displayGraph', val => {
      this.variables.row1 = this.nonSelectedComponentsRow1.filter(item => {
        return item.id === val.component
      })[0]
    })
  },
  watch: {
    logbookType(val, old) {
      if (val !== old) {
        this.variables = {
          row1: null,
          row2: null,
          column1: null,
          column2: null,
          condition: null
        }
      }
    },
    variables: {
      deep: true,
      handler(variables) {
        if (
          variables.row1 &&
          (variables.row1.type === 'icd10' ||
            variables.row1.type === 'icd10-sec' ||
            variables.row1.type === 'icd11' ||
            variables.row1.type === 'multi-select-tree')
        ) {
          this.isDisabled = true
        } else {
          this.isDisabled = false
        }
        if (
          variables.row1 &&
          variables.row1.condition &&
          variables.row1.condition === true
        ) {
          this.isConditional = true
          this.variableOptions = variables.row1.options
        } else {
          this.isConditional = false
        }
        this.$emit('update:vars', variables)
      }
    }
  }
}
</script>
